import { config } from "./domainConfig";

export let Videos360 = [
  {
    "id": 2,
    "contents": 24,
    "categoryName": {
      "en": "Adventure",
      "fr": "Aventure",
      "de": "Abenteuer",
      "be": "Avontuur",
      "tr": "Macera",
      "pt": "Aventura",
      "no": "Eventyr",
      "cy": "Авантура",
      "ee": "Seiklus",
      "th": "การผจญภัย",
      "ar": "مغامرة",
      "gr": "Περιπέτεια",
      "es": "Aventura",
      "it": "Avventura",
      "id": "Petualangan",
      "si": "Avantura",
      "pl": "Przygoda"
    },
    "videos": [
      {
        "duration": 279,
        "id": 30,
        "name": {
          "en": "One Day in Bali",
          "fr": "One Day in Bali",
          "be": "One Day in Bali",
          "tr": "One Day in Bali",
          "de": "One Day in Bali",
          "ar": "One Day in Bali",
          "id": "One Day in Bali",
          "si": "En dan na Baliju",
          "pl": "Jeden dzień na Bali",
          "th": "หนึ่งวันในบาหลี"
        },
        "preview": "https://cdn.mobio360.com/Adventure/One+Day+in+Bali.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Adventure/One+Day+in+Bali.mp4"
      },
      {
        "duration": 21334,
        "id": 200,
        "name": {
          "en": "One Day in Ecuador's Shoreline",
          "fr": "One Day in Ecuador's Shoreline",
          "be": "One Day in Ecuador's Shoreline",
          "tr": "One Day in Ecuador's Shoreline",
          "de": "One Day in Ecuador's Shoreline",
          "ar": "One Day in Ecuador's Shoreline",
          "id": "One Day in Ecuador's Shoreline",
          "si": "En dan na obali Ekvadorja",
          "pl": "Jeden dzień na wybrzeżu Ekwadoru",
          "th": "หนึ่งวันที่ชายฝั่งเอกวาดอร์"
        },
        "preview": "https://cdn.mobio360.com/Adventure/One+Day+in+Ecuador%E2%80%99s+Shoreline.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Adventure/One+Day+in+Ecuador%E2%80%99s+Shoreline.mp4"
      },
      {
        "duration": 21334,
        "id": 201,
        "name": {
          "en": "One Day in Galway & Cliffs of Moher",
          "fr": "One Day in Galway & Cliffs of Moher",
          "be": "One Day in Galway & Cliffs of Moher",
          "tr": "One Day in Galway & Cliffs of Moher",
          "de": "One Day in Galway & Cliffs of Moher",
          "ar": "One Day in Galway & Cliffs of Moher",
          "id": "One Day in Galway & Cliffs of Moher",
          "si": "En dan v Galwayju in na klifih Moher",
          "pl": "Jeden dzień w Galway i na Klifach Moheru",
          "th": "หนึ่งวันที่กัลเวย์และหน้าผาโมเฮอร์"
        },
        "preview": "https://cdn.mobio360.com/Adventure/One+Day+in+Galway+_+Cliffs+of+Moher-001.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Adventure/One+Day+in+Galway+_+Cliffs+of+Moher-001.mp4"
      },
      {
        "duration": 21334,
        "id": 202,
        "name": {
          "en": "One Day in Iceland",
          "fr": "One Day in Iceland",
          "be": "One Day in Iceland",
          "tr": "One Day in Iceland",
          "de": "One Day in Iceland",
          "ar": "One Day in Iceland",
          "id": "One Day in Iceland",
          "si": "En dan na Islandiji",
          "pl": "Jeden dzień w Islandii",
          "th": "หนึ่งวันในไอซ์แลนด์"
        },
        "preview": "https://cdn.mobio360.com/Adventure/One+Day+in+Iceland.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Adventure/One+Day+in+Iceland.mp4"
      },
      {
        "duration": 21334,
        "id": 203,
        "name": {
          "en": "One Day in Madeira, Portugal",
          "fr": "One Day in Madeira, Portugal",
          "be": "One Day in Madeira, Portugal",
          "tr": "One Day in Madeira, Portugal",
          "de": "One Day in Madeira, Portugal",
          "ar": "One Day in Madeira, Portugal",
          "id": "One Day in Madeira, Portugal",
          "si": "En dan na Madeiri, Portugalska",
          "pl": "Jeden dzień na Maderze, Portugalia",
          "th": "หนึ่งวันในมาเดรา ประเทศโปรตุเกส"
        },
        "preview": "https://cdn.mobio360.com/Adventure/One+Day+in+Madeira%2C+Portugal-003.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Adventure/One+Day+in+Madeira%2C+Portugal-003.mp4"
      },
      {
        "duration": 21335,
        "id": 204,
        "name": {
          "en": "One Day in Malta's Beaches",
          "fr": "One Day in Malta's Beaches",
          "be": "One Day in Malta's Beaches",
          "tr": "One Day in Malta's Beaches",
          "de": "One Day in Malta's Beaches",
          "ar": "One Day in Malta's Beaches",
          "id": "One Day in Malta's Beaches",
          "si": "En dan na plažah Malte",
          "pl": "Jeden dzień na plażach Malty",
          "th": "หนึ่งวันบนชายหาดของมอลตา"
        },
        "preview": "https://cdn.mobio360.com/Adventure/One+Day+in+Malta%E2%80%99s+Beaches.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Adventure/One+Day+in+Malta%E2%80%99s+Beaches.mp4"
      },
      {
        "duration": 21336,
        "id": 205,
        "name": {
          "en": "One Day in Santorini, Greece",
          "fr": "One Day in Santorini, Greece",
          "be": "One Day in Santorini, Greece",
          "tr": "One Day in Santorini, Greece",
          "de": "One Day in Santorini, Greece",
          "ar": "One Day in Santorini, Greece",
          "id": "One Day in Santorini, Greece",
          "si": "En dan na Santoriniju, Grčija",
          "pl": "Jeden dzień na Santorini, Grecja",
          "th": "หนึ่งวันในซานโตรินี ประเทศกรีซ"
        },
        "preview": "https://cdn.mobio360.com/Adventure/One+Day+in+Santorini%2C+Greece.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Adventure/One+Day+in+Santorini%2C+Greece.mp4"
      }
    ]
  },  
  {
    id: 17,
    contents: 3,
    categoryName: {
      en: "City Tour",
      fr: "City Tour",
      de: "City Tour",
      be: "City Tour",
      tr: "City Tour",
      pt: "City Tour",
      no: "City Tour",
      cy: "City Tour",
      ee: "City Tour",
      th: "ซิตี้ทัวร์",
      gr: "City Tour",
      es: "City Tour",
      it: "City Tour",
      ar: "City Tour",
      id: "City Tour",
      si: "Mestna tura",
      pl: "Wycieczka po mieście",
    },
    videos: [
      {
        duration: 21334,
        id: 228,
        name: {
          en: "One Day in Bangkok",
          fr: "One Day in Bangkok",
          be: "One Day in Bangkok",
          tr: "One Day in Bangkok",
          de: "One Day in Bangkok",
          ar: "One Day in Bangkok",
          id: "One Day in Bangkok",
          si: "En dan v Bangkoku",
          pl: "Jeden dzień w Bangkoku",
          th: "หนึ่งวันในกรุงเทพฯ",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Bangkok.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Bangkok.mp4",
      },
      {
        duration: 21334,
        id: 229,
        name: {
          en: "One Day in Bogota",
          fr: "One Day in Bogota",
          be: "One Day in Bogota",
          tr: "One Day in Bogota",
          de: "One Day in Bogota",
          ar: "One Day in Bogota",
          id: "One Day in Bogota",
          pl: "Jeden dzień w Bogocie",
          th: "หนึ่งวันในโบโกตา",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Bogota.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Bogota.mp4",
      },
      {
        duration: 21334,
        id: 230,
        name: {
          en: "One Day in Cairo",
          fr: "One Day in Cairo",
          be: "One Day in Cairo",
          tr: "One Day in Cairo",
          de: "One Day in Cairo",
          ar: "One Day in Cairo",
          id: "One Day in Cairo",
          si: "En dan v Bogoti",
          pl: "Jeden dzień w Kairze",
          th: "หนึ่งวันในไคโร",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Cairo.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Cairo.mp4",
      },
      {
        duration: 21334,
        id: 231,
        name: {
          en: "One Day in Jerusalem",
          fr: "One Day in Jerusalem",
          be: "One Day in Jerusalem",
          tr: "One Day in Jerusalem",
          de: "One Day in Jerusalem",
          ar: "One Day in Jerusalem",
          id: "One Day in Jerusalem",
          si: "En dan v Jeruzalemu",
          pl: "Jeden dzień w Jerozolimie",
          th: "หนึ่งวันในเยรูซาเล็ม",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Jerusalem.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Jerusalem.mp4",
      },
      {
        duration: 21334,
        id: 232,
        name: {
          en: "One Day in London",
          fr: "One Day in London",
          be: "One Day in London",
          tr: "One Day in London",
          de: "One Day in London",
          ar: "One Day in London",
          id: "One Day in London",
          si: "En dan v Londonu",
          pl: "Jeden dzień w Londynie",
          th: "หนึ่งวันในลอนดอน",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+London.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+London.mp4",
      },
      {
        duration: 2133,
        id: 238,
        name: {
          en: "One Day in Marrakech",
          fr: "One Day in Marrakech",
          be: "One Day in Marrakech",
          tr: "One Day in Marrakech",
          de: "One Day in Marrakech",
          ar: "One Day in Marrakech",
          id: "One Day in Marrakech",
          si: "En dan v Marakešu",
          pl: "Jeden dzień w Marrakeszu",
          th: "หนึ่งวันในมาร์ราเกช",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Marrakech.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Marrakech.mp4",
      },
      {
        duration: 2133,
        id: 239,
        name: {
          en: "One Day in New York City",
          fr: "One Day in New York City",
          be: "One Day in New York City",
          tr: "One Day in New York City",
          de: "One Day in New York City",
          ar: "One Day in New York City",
          id: "One Day in New York City",
          si: "En dan v New Yorku",
          pl: "Jeden dzień w Nowym Jorku",
          th: "หนึ่งวันในนิวยอร์กซิตี้",
        },
        preview:
          "https://cdn.mobio360.com/City+Tour/One+Day+in+New+York+City.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/City+Tour/One+Day+in+New+York+City.mp44",
      },
      {
        duration: 2133,
        id: 246,
        name: {
          en: "One Day in Paris",
          fr: "One Day in Paris",
          be: "One Day in Paris",
          tr: "One Day in Paris",
          de: "One Day in Paris",
          ar: "One Day in Paris",
          id: "One Day in Paris",
          si: "En dan v Parizu",
          pl: "Jeden dzień w Paryżu",
          th: "หนึ่งวันในปารีส",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Paris.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Paris.mp4",
      },
      {
        duration: 2133,
        id: 247,
        name: {
          en: "One Day in Rome",
          fr: "One Day in Rome",
          be: "One Day in Rome",
          tr: "One Day in Rome",
          de: "One Day in Rome",
          ar: "One Day in Rome",
          id: "One Day in Rome",
          si: "En dan v Rimu",
          pl: "Jeden dzień w Rzymie",
          th: "หนึ่งวันในโรม",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Rome+4K.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Rome+4K.mp4",
      },
      {
        duration: 2133,
        id: 248,
        name: {
          en: "One Day in Singapore",
          fr: "One Day in Singapore",
          be: "One Day in Singapore",
          tr: "One Day in Singapore",
          de: "One Day in Singapore",
          ar: "One Day in Singapore",
          id: "One Day in Singapore",
          si: "En dan v Singapurju",
          pl: "Jeden dzień w Singapurze",
          th: "หนึ่งวันในสิงคโปร์",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Singapore.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Singapore.mp4",
      },
    ],
  },  
  {
    "id": 18,
    "contents": 3,
    "categoryName": {
      "en": "Documentary",
      "fr": "Documentary",
      "de": "Documentary",
      "be": "Documentary",
      "tr": "Documentary",
      "pt": "Documentary",
      "no": "Documentary",
      "cy": "Documentary",
      "ee": "Documentary",
      "th": "สารคดี",
      "gr": "Documentary",
      "es": "Documentary",
      "it": "Documentary",
      "ar": "Documentary",
      "id": "Documentary",
      "si": "Dokumentarec",
      "pl": "Dokument"
    },
    "videos": [
      {
        "duration": 21334,
        "id": 233,
        "name": {
          "en": "One Day in Siem Reap",
          "fr": "One Day in Siem Reap",
          "be": "One Day in Siem Reap",
          "tr": "One Day in Siem Reap",
          "de": "One Day in Siem Reap",
          "ar": "One Day in Siem Reap",
          "id": "One Day in Siem Reap",
          "si": "En dan v Siem Reapu",
          "pl": "Jeden dzień w Siem Reap",
          "th": "หนึ่งวันในเสียมเรียบ"
        },
        "preview": "https://cdn.mobio360.com/Documentary/One+Day+in+Siem+Reap.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Documentary/One+Day+in+Siem+Reap.mp4"
      },
      {
        "duration": 21334,
        "id": 234,
        "name": {
          "en": "One Day in the Republic of Congo",
          "fr": "One Day in the Republic of Congo",
          "be": "One Day in the Republic of Congo",
          "tr": "One Day in the Republic of Congo",
          "de": "One Day in the Republic of Congo",
          "ar": "One Day in the Republic of Congo",
          "id": "One Day in the Republic of Congo",
          "si": "En dan v Republiki Kongo",
          "pl": "Jeden dzień w Republice Konga",
          "th": "หนึ่งวันในสาธารณรัฐคองโก"
        },
        "preview": "https://cdn.mobio360.com/Documentary/One+Day+in+the+Republic+of+Congo.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Documentary/One+Day+in+the+Republic+of+Congo.mp4"
      },
      {
        "duration": 21334,
        "id": 235,
        "name": {
          "en": "Holi Festival in India",
          "fr": "Holi Festival in India",
          "be": "Holi Festival in India",
          "tr": "Holi Festival in India",
          "de": "Holi Festival in India",
          "ar": "Holi Festival in India",
          "id": "Holi Festival in India",
          "si": "Festival Holi v Indiji",
          "pl": "Festiwal Holi w Indiach",
          "th": "เทศกาลโฮลีในอินเดีย"
        },
        "preview": "https://cdn.mobio360.com/Documentary/Holi+Festival+in+India.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Documentary/Holi+Festival+in+India.mp4"
      },
      {
        "duration": 21334,
        "id": 236,
        "name": {
          "en": "Explore Agra",
          "fr": "Explore Agra",
          "be": "Explore Agra",
          "tr": "Explore Agra",
          "de": "Explore Agra",
          "ar": "Explore Agra",
          "id": "Explore Agra",
          "si": "Raziskovanje Agre",
          "pl": "Poznaj Agrę",
          "th": "สำรวจอักรา"
        },
        "preview": "https://cdn.mobio360.com/Documentary/Explore+Agra.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Documentary/Explore+Agra.mp4"
      },
      {
        "duration": 21334,
        "id": 237,
        "name": {
          "en": "One Day with a Figure Skater",
          "fr": "One Day with a Figure Skater",
          "be": "One Day with a Figure Skater",
          "tr": "One Day with a Figure Skater",
          "de": "One Day with a Figure Skater",
          "ar": "One Day with a Figure Skater",
          "id": "One Day with a Figure Skater",
          "si": "En dan s figuralnim drsalcem",
          "pl": "Jeden dzień z łyżwiarzem figurowym",
          "th": "หนึ่งวันกับนักสเก็ตลีลา"
        },
        "preview": "https://cdn.mobio360.com/Documentary/One+Day+with+a+Figure+Skater.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Documentary/One+Day+with+a+Figure+Skater.mp4"
      },
      {
        "duration": 21334,
        "id": 249,
        "name": {
          "en": "Figure Skating Routine",
          "fr": "Figure Skating Routine",
          "be": "Figure Skating Routine",
          "tr": "Figure Skating Routine",
          "de": "Figure Skating Routine",
          "ar": "Figure Skating Routine",
          "id": "Figure Skating Routine",
          "si": "Rutina umetnostnega drsanja",
          "pl": "Rutyna łyżwiarska",
          "th": "ท่ารำสเก็ตลีลา"
        },
        "preview": "https://cdn.mobio360.com/Documentary/Figure+Skating+Routine.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Documentary/Figure+Skating+Routine.mp4"
      }
    ]
  },  
  {
    id: 16,
    contents: 4,
    categoryName: {
      en: "Meditation",
      fr: "Meditation",
      de: "Meditation",
      be: "Meditation",
      tr: "Meditation",
      pt: "Meditation",
      no: "Meditation",
      cy: "Meditation",
      ee: "Meditation",
      th: "การทำสมาธิ",
      ar: "Meditation",
      gr: "Meditation",
      es: "Meditation",
      id: "Meditation",
      si: "Meditacija",
      pl: "Medytacja",
    },
    videos: [
      {
        duration: 21334,
        id: 220,
        name: {
          en: "Meditation in Bali",
          fr: "Meditation in Bali",
          be: "Meditation in Bali",
          tr: "Meditation in Bali",
          de: "Meditation in Bali",
          ar: "Meditation in Bali",
          id: "Meditation in Bali",
          si: "Meditacija na Baliju",
          pl: "Medytacja na Bali",
          th: "การทำสมาธิในบาหลี"
        },
        preview:
          "https://cdn.mobio360.com/Meditation/Meditation+in+Bali-004.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Meditation/Meditation+in+Bali-004.mp4",
      },
      {
        duration: 21334,
        id: 221,
        name: {
          en: "Guided Meditation in the Azores Islands",
          fr: "Guided Meditation in the Azores Islands",
          be: "Guided Meditation in the Azores Islands",
          tr: "Guided Meditation in the Azores Islands",
          de: "Guided Meditation in the Azores Islands",
          ar: "Guided Meditation in the Azores Islands",
          id: "Guided Meditation in the Azores Islands",
          si: "Vodenje meditacije na Azorskih otokih",
          pl: "Medytacja z przewodnikiem na Wyspach Azorach",
          th: "การทำสมาธิแบบมีผู้แนะนำที่หมู่เกาะอะซอเรส"
        },
        preview:
          "https://cdn.mobio360.com/Meditation/Guided+Meditation+in+the+Azores+Islands-002.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Meditation/Guided+Meditation+in+the+Azores+Islands-002.mp4",
      },
      {
        duration: 21334,
        id: 222,
        name: {
          en: "Box breathing in Nature",
          fr: "Box breathing in Nature",
          be: "Box breathing in Nature",
          tr: "Box breathing in Nature",
          de: "Box breathing in Nature",
          ar: "Box breathing in Nature",
          id: "Box breathing in Nature",
          si: "Dihanje v obliki škatle v naravi",
          pl: "Oddychanie pudełkowe w naturze",
          th: "การหายใจแบบกล่องในธรรมชาติ"
        },
        preview:
          "https://cdn.mobio360.com/Meditation/Box+breathing+in+Nature.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Meditation/Box+breathing+in+Nature.mp4",
      },
      {
        duration: 21334,
        id: 223,
        name: {
          en: "Cliff and waves meditation",
          fr: "Cliff and waves meditation",
          be: "Cliff and waves meditation",
          tr: "Cliff and waves meditation",
          de: "Cliff and waves meditation",
          ar: "Cliff and waves meditation",
          id: "Cliff and waves meditation",
          si: "Meditacija na klifu in ob valovih",
          pl: "Medytacja na klifie i falach",
          th: "การทำสมาธิบนหน้าผาและเกลียวคลื่น"
        },
        preview:
          "https://cdn.mobio360.com/Meditation/Cliff+and+waves+meditation.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Meditation/Cliff+and+waves+meditation.mp4",
      },
      {
        duration: 21334,
        id: 224,
        name: {
          en: "Beach with shells meditation",
          fr: "Beach with shells meditation",
          be: "Beach with shells meditation",
          tr: "Beach with shells meditation",
          de: "Beach with shells meditation",
          ar: "Beach with shells meditation",
          id: "Beach with shells meditation",
          si: "Meditacija na plaži s školjkami",
          pl: "Medytacja na plaży z muszlami",
          th: "การทำสมาธิบนชายหาดที่มีเปลือกหอย"
        },
        preview:
          "https://cdn.mobio360.com/Meditation/Beach+with+shells+meditation.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Meditation/Beach+with+shells+meditation.mp4",
      },
      {
        duration: 21334,
        id: 225,
        name: {
          en: "Coast ocean Meditation",
          fr: "Coast ocean Meditation",
          be: "Coast ocean Meditation",
          tr: "Coast ocean Meditation",
          de: "Coast ocean Meditation",
          ar: "Coast ocean Meditation",
          id: "Coast ocean Meditation",
          si: "Meditacija ob morju",
          pl: "Medytacja nad oceanem",
          th: "การทำสมาธิริมชายฝั่งมหาสมุทร"
        },
        preview:
          "https://cdn.mobio360.com/Meditation/Coast+Ocean+Meditation.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Meditation/Coast+Ocean+Meditation.mp4",
      },
      {
        duration: 21334,
        id: 226,
        name: {
          en: "Cliff meditation",
          fr: "Cliff meditation",
          be: "Cliff meditation",
          tr: "Cliff meditation",
          de: "Cliff meditation",
          ar: "Cliff meditation",
          id: "Cliff meditation",
          si: "Meditacija na klifu",
          pl: "Medytacja na klifie",
          th: "การทำสมาธิบนหน้าผา"
        },
        preview: "https://cdn.mobio360.com/Meditation/Cliffs+Meditation.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Meditation/Cliffs+Meditation.mp4",
      },  
      // {
      //   duration: 21334,
      //   id: 227,
      //   name: {
      //     en: "Views From Machu Picchu Peru South America",
      //     fr: "Vues du Machu Picchu Pérou Amérique du Sud",
      //     be: "Uitzichten Van Machu Picchu Peru Zuid-Amerika",
      //     tr: "Views From Machu Picchu Peru South America",
      //     de: "Ansichten von Machu Picchu Peru Südamerika",
      //     ar: "مناظر من ماتشو بيتشو بيرو أمريكا الجنوبية",
      //     id: "Pemandangan dari Machu Picchu Peru Amerika Selatan"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Mountain+and+Sea/Views+From+Machu+Picchu+Peru+South+America.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Mountain+and+Sea/Views+From+Machu+Picchu+Peru+South+America.mp4",
      // },
    ],
  },
  {
    "id": 13,
    "contents": 10,
    "categoryName": {
      "en": "Nature",
      "fr": "Nature",
      "de": "Natur",
      "be": "Natuur",
      "tr": "Doğa",
      "pt": "Natureza",
      "no": "Natur",
      "cy": "Nature",
      "ee": "Loodus",
      "th": "ธรรมชาติ",
      "gr": "Φύση",
      "ar": "طبيعة سجية",
      "es": "Naturaleza",
      "it": "Natura",
      "id": "Alam",
      "si": "Narava",
      "pl": "Przyroda"
    },
    "videos": [
      {
        "duration": 21334,
        "id": 204,
        "name": {
          "en": "Collections: Panoramic Nature Views",
          "fr": "Collections: Panoramic Nature Views",
          "be": "Collections: Panoramic Nature Views",
          "tr": "Collections: Panoramic Nature Views",
          "de": "Collections: Panoramic Nature Views",
          "ar": "Collections: Panoramic Nature Views",
          "id": "Collections: Panoramic Nature Views",
          "si": "Kolekcije: Panoramski pogledi na naravo",
          "pl": "Kolekcje: Panoramiczne widoki przyrody",
          "th": "คอลเลกชัน: วิวธรรมชาติแบบพาโนรามา"
        },
        "preview": "https://cdn.mobio360.com/Nature/Collections_+Panoramic+Nature+Views.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Nature/Collections_+Panoramic+Nature+Views.mp4"
      },
      {
        "duration": 21334,
        "id": 205,
        "name": {
          "en": "Collections: Stunning Beaches",
          "fr": "Collections: Stunning Beaches",
          "be": "Collections: Stunning Beaches",
          "tr": "Collections: Stunning Beaches",
          "de": "Collections: Stunning Beaches",
          "ar": "Collections: Stunning Beaches",
          "id": "Collections: Stunning Beaches",
          "pl": "Kolekcje: Oszałamiające plaże",
          "th": "คอลเลกชัน: ชายหาดที่สวยงามตระการตา"
        },
        "preview": "https://cdn.mobio360.com/Nature/Collections_+Stunning+Beaches.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Nature/Collections_+Stunning+Beaches.mp4"
      },  
      // {
      //   duration: 21334,
      //   id: 206,
      //   name: {
      //     en: "Diamondback Rattlesnake In The Arid Desert 2021",
      //     fr: "Crotale à dos de diamant dans le désert aride 2021",
      //     be: "Diamantrug ratelslang in de dorre woestijn 2021",
      //     tr: "Diamondback Rattlesnake In The Arid Desert 2021",
      //     de: "Diamantrücken-Klapperschlange in der Ödlandwüste 2021",
      //     ar: "أفعى الجرسية ذات الظهر الماسي في الصحراء القاحلة 2021",
      //     id: "Ular berbisa Diamondback di Gurun Kering 2021"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Nature/Diamondback+Rattlesnake+In+The+Arid+Desert+2021.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Nature/Diamondback+Rattlesnake+In+The+Arid+Desert+2021.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 207,
      //   name: {
      //     en: "Gentoo Penguins Antarctica",
      //     fr: "Manchots Gentoo en Antarctique",
      //     be: "Ezelspinguïns op Antarctica",
      //     tr: "Gentoo Penguins Antarctica",
      //     de: "Eselspinguine in der Antarktis",
      //     ar: "طيور البطريق جينتو أنتاركتيكا",
      //     id: "Penguin Gentoo Antartika"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Nature/Gentoo+Penguins+Antarctica.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Nature/Gentoo+Penguins+Antarctica.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 208,
      //   name: {
      //     en: "Playful Capuchin Monkeys In The Jungle 2021",
      //     fr: "Singes capucins enjoués dans la jungle 2021",
      //     be: "Speelse kapucijneraapjes in de jungle 2021",
      //     tr: "Playful Capuchin Monkeys In The Jungle 2021",
      //     de: "Verspielte Kapuzineräffchen im Dschungel 2021",
      //     ar: "قرود كابوشين مرحة في الغابة 2021",
      //     id: "Monyet Capuchin yang Penuh Main di Hutan 2021"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Nature/Playful+Capuchin+Monkeys+In+The+Jungle+2021.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Nature/Playful+Capuchin+Monkeys+In+The+Jungle+2021.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 209,
      //   name: {
      //     en: "Schrainbach Waterfall Konigssee Lake Berchtesgaden National Park Bavaria Germany Europe",
      //     fr: "Cascade de Schrainbach Lac de Konigssee Parc national de Berchtesgaden Bavière Allemagne Europe",
      //     be: "Schrainbach Waterval Konigssee Meer Berchtesgaden Nationaal Park Bavaria Duitsland Europa",
      //     tr: "Schrainbach Waterfall Konigssee Lake Berchtesgaden National Park Bavaria Germany Europe",
      //     de: "Schrainbach Wasserfall Königssee Nationalpark Berchtesgadener Land Bayern Deutschland Europa",
      //     ar: " شلال سخرينباش كونغسه و بحيرة بيرختجادين ناشونال بارك في بافاريا ألمانيا في أوروبا",
      //     id: "Air Terjun Schrainbach Danau Konigssee Taman Nasional Berchtesgaden Bavaria Jerman Eropa"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Nature/Schrainbach+Waterfall+Konigssee+Lake+Berchtesgaden+National+Park+Bavaria+Germany+Europe.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Nature/Schrainbach+Waterfall+Konigssee+Lake+Berchtesgaden+National+Park+Bavaria+Germany+Europe.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 210,
      //   name: {
      //     en: "View Over Cliff Edge Victoria Falls Zambezi River Africa",
      //     fr: "Vue sur le bord de la falaise Chutes Victoria Fleuve Zambèze Afrique",
      //     be: "Uitzicht over klifrand Victoria Falls Zambezi Rivier Afrika",
      //     tr: "View Over Cliff Edge Victoria Falls Zambezi River Africa",
      //     de: "Blick über den Klippenrand Victoria Falls Sambesi Fluss Afrika",
      //     ar: "منظر على كليف إيدج فيكتوريا فولز نهر زامبيزي أفريقيا",
      //     id: "Pemandangan di tepi jurang Victoria Falls Sungai Zambezi Afrika"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Nature/View+Over+Cliff+Edge+Victoria+Falls+Zambezi+River+Africa.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Nature/View+Over+Cliff+Edge+Victoria+Falls+Zambezi+River+Africa.mp4",
      // },
    ],
  },
  {
    "id": 14,
    "contents": 10,
    "categoryName": {
      "en": "Animals",
      "fr": "Animals",
      "de": "Animals",
      "be": "Animals",
      "tr": "Animals",
      "pt": "Animals",
      "no": "Animals",
      "cy": "Animals",
      "ee": "Animals",
      "th": "สัตว์",
      "gr": "Animals",
      "es": "Animals",
      "it": "Animals",
      "ar": "Animals",
      "id": "Animals",
      "si": "Živali",
      "pl": "Zwierzęta"
    },
    "videos": [
      {
        "duration": 21334,
        "id": 211,
        "name": {
          "en": "Animals Up Close",
          "fr": "Animals Up Close",
          "be": "Animals Up Close",
          "tr": "Animals Up Close",
          "de": "Animals Up Close",
          "ar": "Animals Up Close",
          "id": "Animals Up Close",
          "si": "Živali od blizu",
          "pl": "Zwierzęta z bliska",
          "th": "สัตว์ในระยะใกล้"
        },
        "preview": "https://cdn.mobio360.com/Animals/Animals+Up+Close.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Animals/Animals+Up+Close.mp4"
      },
      {
        "duration": 21334,
        "id": 212,
        "name": {
          "en": "Farm Animals",
          "fr": "Farm Animals",
          "be": "Farm Animals",
          "tr": "Farm Animals",
          "de": "Farm Animals",
          "ar": "Farm Animals",
          "id": "Farm Animals",
          "si": "Kmetijske živali",
          "pl": "Zwierzęta gospodarskie",
          "th": "สัตว์ในฟาร์ม"
        },
        "preview": "https://cdn.mobio360.com/Animals/Farm+Animals-001.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Animals/Farm+Animals-001.mp4"
      },
      {
        "duration": 21334,
        "id": 213,
        "name": {
          "en": "Animals in the Zoo",
          "fr": "Animals in the Zoo",
          "be": "Animals in the Zoo",
          "tr": "Animals in the Zoo",
          "de": "Animals in the Zoo",
          "ar": "Animals in the Zoo",
          "id": "Animals in the Zoo",
          "si": "Živali v živalskem vrtu",
          "pl": "Zwierzęta w zoo",
          "th": "สัตว์ในสวนสัตว์"
        },
        "preview": "https://cdn.mobio360.com/Animals/Animals+in+the+Zoo.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Animals/Animals+in+the+Zoo.mp4"
      },  
      // {
      //   duration: 21334,
      //   id: 214,
      //   name: {
      //     en: "One Day In Cairo English Voiceover",
      //     fr: "Un jour au Caire Voix off en anglais",
      //     be: "Een dag in Caïro Engelse Voice-over",
      //     tr: "One Day In Berlin English Voiceover",
      //     de: "Ein Tag in Kairo Englisch Voice-over",
      //     ar: "يوم واحد في الصوتية الإنجليزية القاهرة",
      //     id: "Satu Hari di Kairo Voiceover Bahasa Indonesia"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Cairo+English+Voiceover.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Cairo+English+Voiceover.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 215,
      //   name: {
      //     en: "One Day In Kuala-Lumpur English Voiceover",
      //     fr: "Un jour à Kuala-Lumpur Voix off en anglais",
      //     be: "Een Dag In Kuala-Lumpur Engelse Voice-over",
      //     tr: "One Day In Kuala-Lumpur English Voiceover",
      //     de: "Ein Tag in Kuala-Lumpur Englisch Voice-over",
      //     ar: "يوم واحد في التعليق الصوتي باللغة الإنجليزية في كوالالمبور ",
      //     id: "Satu Hari di Kuala Lumpur Voiceover Bahasa Indonesia"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Kuala-Lumpur+English+Voiceover.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Kuala-Lumpur+English+Voiceover.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 216,
      //   name: {
      //     en: "One Day In London English Voiceover",
      //     fr: "Un jour à Londre Voix off en anglais",
      //     be: "Een Dag In Londen Engelse Voice-over",
      //     tr: "One Day In London English Voiceover",
      //     de: "Ein Tag in London Englisch Voice-over",
      //     ar: "يوم واحد في التعليق الصوتي الإنجليزي في لندن",
      //     id: "Satu Hari di London Suara Bahasa Inggris"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+London+English+Voiceover.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+London+English+Voiceover.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 217,
      //   name: {
      //     en: "One Day In Madrid English Voiceover",
      //     fr: "Un jour à Madrid Voix off en anglais",
      //     be: "Een Dag In Madrid Engelse Voice-over",
      //     tr: "One Day In Madrid English Voiceover",
      //     de: "Ein Tag in Madrid Englisch Voice-over",
      //     ar: "يوم واحد في صناديق التعليق الصوتي للمدريد",
      //     id: "Satu Hari di Madrid Suara Bahasa Inggris"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Madrid+English+Voiceover.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Madrid+English+Voiceover.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 218,
      //   name: {
      //     en: "One Day In New-York City English Voiceover",
      //     fr: "Un jour à New-York Voix off anglaise",
      //     be: "Een Dag In New-York City Engelse Voice-over",
      //     tr: "One Day In New-York City English Voiceover",
      //     de: "Ein Tag in New York City Englisch Voice-over",
      //     ar: "يوم واحد في صناديق الصوتية الإنجليزية في مدينة نيويورك",
      //     id: "Satu Hari di Kota New York Suara Bahasa Inggris"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+New-York+City+English+Voiceover.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+New-York+City+English+Voiceover.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 219,
      //   name: {
      //     en: "One Day In Paris English Voiceover",
      //     fr: "Un jour à Paris Voix off en anglais",
      //     be: "Een Dag In Parijs Engelse Voice-over",
      //     tr: "One Day In Paris English Voiceover",
      //     de: "Ein Tag in Paris Englisch Voice-over",
      //     ar: "يوم واحد في التعليق الصوتي الإنجليزي باريس",
      //     id: "Satu Hari di Paris Suara Bahasa Inggris"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Paris+English+Voiceover.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Paris+English+Voiceover.mp4",
      // },
    ],
  },
  {
    "id": 15,
    "contents": 7,
    "categoryName": {
      "en": "Music",
      "id": "Music",
      "si": "Glasba",
      "pl": "Muzyka",
      "th": "ดนตรี"
    },
    "videos": [
      {
        "duration": 21334,
        "id": 800,
        "name": {
          "en": "Turkish March - Wolfgang Amadeus Mozart",
          "id": "Turkish March - Wolfgang Amadeus Mozart",
          "si": "Turška marša - Wolfgang Amadeus Mozart",
          "pl": "Marsz turecki – Wolfgang Amadeusz Mozart",
          "th": "เพลงเดินตุรกี - โวล์ฟกัง อมาเดอุส โมซาร์ท"
        },
        "preview": "https://cdn.mobio360.com/Music/Turkish+March+-+Wolfgang+Amadeus+Mozart.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Music/Turkish+March+-+Wolfgang+Amadeus+Mozart.mp4"
      },
      // {
      //   duration: 21334,
      //   id: 757,
      //   name: {
      //     en: "VRiczat Cricket 360 Video",
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Cricket/VRiczat+Cricket+360+Video.jpeg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Cricket/VRiczat+Cricket+360+Video.mp4",
      // },
      {
        "duration": 21334,
        "id": 801,
        "name": {
          "en": "Storm - Antonio Vivaldi",
          "id": "Storm - Antonio Vivaldi",
          "si": "Nevihta - Antonio Vivaldi",
          "pl": "Burza – Antonio Vivaldi",
          "th": "พายุ - อันโตนิโอ วิวัลดี"
        },
        "preview": "https://cdn.mobio360.com/Music/Storm+-+Antonio+Vivaldi.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Music/Storm+-+Antonio+Vivaldi.mp4"
      },
      {
        "duration": 21334,
        "id": 802,
        "name": {
          "en": "Preludium C major - Johann Sebastian Bach",
          "id": "Preludium C major - Johann Sebastian Bach",
          "si": "Preludij C dur - Johann Sebastian Bach",
          "pl": "Preludium C-dur – Johann Sebastian Bach",
          "th": "พรีลูด C เมเจอร์ - โยฮันน์ เซบาสเตียน บาค"
        },
        "preview": "https://cdn.mobio360.com/Music/Preludium+C+major+-+Johann+Sebastian+Bach.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Music/Preludium+C+major+-+Johann+Sebastian+Bach.mp4"
      },
      {
        "duration": 21334,
        "id": 803,
        "name": {
          "en": "Bugatti Step - Jaroslav Ježek",
          "id": "Bugatti Step - Jaroslav Ježek",
          "si": "Bugatti korak - Jaroslav Ježek",
          "pl": "Bugatti Step – Jaroslav Ježek",
          "th": "บูกัตติ สเต็ป - ยาโรสลาฟ เยเช็ค"
        },
        "preview": "https://cdn.mobio360.com/Music/Bugatti+Step+-+Jaroslav+Jez%CC%8Cek.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Music/Bugatti+Step+-+Jaroslav+Jez%CC%8Cek.mp4"
      },
    ],
  },
  {
    "id": 16,
    "contents": 6,
    "categoryName": {
      "en": "Fitness",
      "id": "Fitness",
      "si": "Fitnes",
      "pl": "Fitness",
      "th": "ฟิตเนส"
    },
    "videos": [
      {
        "duration": 21334,
        "id": 900,
        "name": {
          "en": "HIIT Back",
          "id": "HIIT Back",
          "si": "HIIT za hrbet",
          "pl": "HIIT na plecy",
          "th": "HIIT หลัง"
        },
        "preview": "https://cdn.mobio360.com/Fitness/HIITBack.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Fitness/HIIT+Back.mp4"
      },
      {
        "duration": 21334,
        "id": 901,
        "name": {
          "en": "HIIT Cardio and Planks",
          "id": "HIIT Cardio and Planks",
          "si": "HIIT kardio in deske",
          "pl": "HIIT cardio i deski",
          "th": "HIIT คาร์ดิโอและแพลงก์"
        },
        "preview": "https://cdn.mobio360.com/Fitness/HIITCardio+and+Planks.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Fitness/HIIT+Plank+%26+Cardio.mp4"
      },
      {
        "duration": 21334,
        "id": 902,
        "name": {
          "en": "HIIT Glutes",
          "id": "HIIT Glutes",
          "si": "HIIT za zadnjico",
          "pl": "HIIT na pośladki",
          "th": "HIIT กล้ามเนื้อสะโพก"
        },
        "preview": "https://cdn.mobio360.com/Fitness/HIITGlutes.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Fitness/HIIT+Glutes.mp4"
      },
      {
        "duration": 21334,
        "id": 903,
        "name": {
          "en": "HIIT Core",
          "id": "HIIT Core",
          "si": "HIIT za jedro",
          "pl": "HIIT na mięśnie brzucha",
          "th": "HIIT กล้ามท้อง"
        },
        "preview": "https://cdn.mobio360.com/Fitness/HIITCore.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Fitness/HIIT+Core.mp4"
      },
      {
        "duration": 21334,
        "id": 904,
        "name": {
          "en": "HIIT Triceps",
          "id": "HIIT Triceps",
          "si": "HIIT za tricepse",
          "pl": "HIIT na tricepsy",
          "th": "HIIT ไตรเซ็ปส์"
        },
        "preview": "https://cdn.mobio360.com/Fitness/HIITTriceps+.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Fitness/HIIT+Triceps.mp4"
      },
      {
        "duration": 21334,
        "id": 905,
        "name": {
          "en": "HIIT Shoulders",
          "id": "HIIT Shoulders",
          "si": "HIIT za ramena",
          "pl": "HIIT na barki",
          "th": "HIIT ไหล่"
        },
        "preview": "https://cdn.mobio360.com/Fitness/HIITShoulders.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Fitness/HIIT+Shoulders.mp4"
      },
      {
        "duration": 21334,
        "id": 906,
        "name": {
          "en": "Outdoor HIIT Cardio and Planks",
          "id": "Outdoor HIIT Cardio and Planks",
          "si": "Zunanji HIIT kardio in deske",
          "pl": "Outdoor HIIT cardio i deski",
          "th": "HIIT กลางแจ้ง คาร์ดิโอและแพลงก์"
        },
        "preview": "https://cdn.mobio360.com/Fitness/OutdoorHIITCardio.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Fitness/Outdoor+HIIT+Cardio+and+Planks.mp4"
      },
      {
        "duration": 21334,
        "id": 907,
        "name": {
          "en": "Outdoor HIIT Shoulders",
          "id": "Outdoor HIIT Shoulders",
          "si": "Zunanji HIIT za ramena",
          "pl": "Outdoor HIIT na barki",
          "th": "HIIT ไหล่กลางแจ้ง"
        },
        "preview": "https://cdn.mobio360.com/Fitness/OutdoorHIITShoulders.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Fitness/Outdoor+HIIT+Shoulders.mp4"
      },
      {
        "duration": 21334,
        "id": 908,
        "name": {
          "en": "Outdoor HIIT Legs",
          "id": "Outdoor HIIT Legs",
          "si": "Zunanji HIIT za noge",
          "pl": "Outdoor HIIT na nogi",
          "th": "HIIT ขากลางแจ้ง"
        },
        "preview": "https://cdn.mobio360.com/Fitness/OutdoorHIITLegs.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Fitness/Outdoor+HIIT+Legs.mp4"
      },
      {
        "duration": 21334,
        "id": 909,
        "name": {
          "en": "Outdoor HIIT Butts and Guts",
          "id": "Outdoor HIIT Butts and Guts",
          "si": "Zunanji HIIT za zadnjico in trebuh",
          "pl": "Outdoor HIIT na pośladki i brzuch",
          "th": "HIIT กลางแจ้ง สะโพกและหน้าท้อง"
        },
        "preview": "https://cdn.mobio360.com/Fitness/OutdoorHIITButtsandGuts.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Fitness/Outdoor+HIIT+Butts+and+Guts.mp4"
      },
      {
        "duration": 21334,
        "id": 910,
        "name": {
          "en": "Outdoor HIIT Back and Cardio",
          "id": "Outdoor HIIT Back and Cardio",
          "si": "Zunanji HIIT za hrbet in kardio",
          "pl": "Outdoor HIIT na plecy i cardio",
          "th": "HIIT กลางแจ้ง หลังและคาร์ดิโอ"
        },
        "preview": "https://cdn.mobio360.com/Fitness/OutdoorHIITBackandCardio.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Fitness/Outdoor+HIIT+Back+and+Cardio.mp4"
      },
      {
        "duration": 21334,
        "id": 911,
        "name": {
          "en": "Outdoor HIIT Biceps and Triceps",
          "id": "Outdoor HIIT Biceps and Triceps",
          "si": "Zunanji HIIT za bicepse in tricepse",
          "pl": "Outdoor HIIT na bicepsy i tricepsy",
          "th": "HIIT กลางแจ้ง ไบเซ็ปส์และไตรเซ็ปส์"
        },
        "preview": "https://cdn.mobio360.com/Fitness/OutdoorHIITBicepsandTriceps.png",
        "desc": "",
        "videoUrl": "https://cdn.mobio360.com/Fitness/Outdoor+HIIT+Biceps+and+Triceps.mp4"
      }
    ]
  },  
  {
    id: 17,
    contents: 7,
    categoryName: {
      en: "Yoga",
      id: "Yoga",
      si: "Joga",
      pl: "Joga",
      th: "โยคะ"
    },
    videos: [
      {
        duration: 21334,
        id: 912,
        name: {
          en: "Sun Salutation",
          id: "Sun Salutation",
          si: "Pozdrav soncu",
          pl: "Powitanie słońca",
          th: "ท่าไหว้พระอาทิตย์"
        },
        preview: "https://cdn.mobio360.com/Yoga/SunSalutation.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Yoga/Sun+Salutation.mp4"
      },
      // {
      //   duration: 21334,
      //   id: 757,
      //   name: {
      //     en: "VRiczat Cricket 360 Video",
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Cricket/VRiczat+Cricket+360+Video.jpeg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Cricket/VRiczat+Cricket+360+Video.mp4",
      // },
      {
        duration: 21334,
        id: 913,
        name: {
          en: "Sommelier and Triangle Yoga Postures",
          id: "Sommelier and Triangle Yoga Postures",
          si: "Sommeler in trikotne joga drže",
          pl: "Sommelier i postawy jogi w kształcie trójkąta",
          th: "ท่าโซเมอลิเยร์และท่าสามเหลี่ยม"
        },
        preview: "https://cdn.mobio360.com/Yoga/SommelierandTriangle.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Yoga/Sommelier+and+Triangle+Yoga+Postures.mp4"
      },
      {
        duration: 21334,
        id: 914,
        name: {
          en: "Sun Salutation and chrysalis",
          id: "Sun Salutation and chrysalis",
          si: "Pozdrav soncu in hrošč",
          pl: "Powitanie słońca i poczwarka",
          th: "ท่าไหว้พระอาทิตย์และท่าดักแด้"
        },
        preview: "https://cdn.mobio360.com/Yoga/SunSalutationandchrysalis.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Yoga/Sun+Salutation+and+chrysalis+yoga.mp4"
      },
      {
        duration: 21334,
        id: 915,
        name: {
          en: "Kneeling Postures",
          id: "Kneeling Postures",
          si: "Kolena drže",
          pl: "Postawy klęczące",
          th: "ท่าคุกเข่า"
        },
        preview: "https://cdn.mobio360.com/Yoga/KneelingPostures.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Yoga/Kneeling+Postures+Yoga.mp4"
      },
      {
        duration: 21334,
        id: 916,
        name: {
          en: "Neck and Shoulder",
          id: "Neck and Shoulder",
          si: "Vrat in ramena",
          pl: "Szyja i barki",
          th: "คอและไหล่"
        },
        preview: "https://cdn.mobio360.com/Yoga/NeckandShoulder.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Yoga/Neck+and+Shoulder+Yoga.mp4"
      },
      {
        duration: 21334,
        id: 917,
        name: {
          en: "Open-hip seated Yoga postures",
          id: "Open-hip seated Yoga postures",
          si: "Joga drže s odprtimi kolki",
          pl: "Postawy jogi w siadzie z otwartymi biodrami",
          th: "ท่าโยคะนั่งเปิดสะโพก"
        },
        preview: "https://cdn.mobio360.com/Yoga/Open-hip.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Yoga/Open-hip+seated+Yoga+postures.mp4"
      },
      {
        duration: 21334,
        id: 918,
        name: {
          en: "Outdoor The sun series yoga",
          id: "Outdoor The sun series yoga",
          si: "Zunanja joga serija sonca",
          pl: "Joga na świeżym powietrzu – seria słońca",
          th: "โยคะชุดท่าพระอาทิตย์กลางแจ้ง"
        },
        preview: "https://cdn.mobio360.com/Yoga/Outdoorsunseries+.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Yoga/Outdoor+Sun+Series+Yoga.mp4"
      },
      {
        duration: 21334,
        id: 919,
        name: {
          en: "Outdoor Vinyasa Flow",
          id: "Outdoor Vinyasa Flow",
          si: "Zunanja Vinyasa Flow",
          pl: "Outdoor Vinyasa Flow",
          th: "วินยาสะโฟลว์กลางแจ้ง"
        },
        preview: "https://cdn.mobio360.com/Yoga/OutdoorVinyasa.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Yoga/Outdoor+Vinyasa+flow.mp4"
      },
      {
        duration: 21334,
        id: 920,
        name: {
          en: "Outdoor Hip-Opener Yoga",
          id: "Outdoor Hip-Opener Yoga",
          si: "Zunanja joga za odpiranje kolkov",
          pl: "Outdoor joga otwierająca biodra",
          th: "โยคะเปิดสะโพกกลางแจ้ง"
        },
        preview: "https://cdn.mobio360.com/Yoga/OutdoorHip-Opener+.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Yoga/Outdoor+Hip+Opener+Yoga.mp4"
      },
      {
        duration: 21334,
        id: 921,
        name: {
          en: "Outdoor Neck and Shoulders Yoga",
          id: "Outdoor Neck and Shoulders Yoga",
          si: "Zunanja joga za vrat in ramena",
          pl: "Outdoor joga otwierająca biodra",
          th: "โยคะคอและไหล่กลางแจ้ง"
        },
        preview: "https://cdn.mobio360.com/Yoga/OutdoorNeckandShoulders.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Yoga/Outdoor+Neck+and+Shoulders+Yoga.mp4"
      },
      {
        duration: 21334,
        id: 922,
        name: {
          en: "Outdoor Leg Yoga",
          id: "Outdoor Leg Yoga",
          si: "Zunanja joga za noge",
          pl: "Outdoor joga na nogi",
          th: "โยคะขากลางแจ้ง"
        },
        preview: "https://cdn.mobio360.com/Yoga/OutdoorLegYoga.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Yoga/Outdoor+Leg+Yoga.mp4"
      }
    ]
  },
];

export let SportsVideos360ZA = [
  {
    id: 75,
    contents: 7,
    categoryName: {
      en: "Cricket",
      id: "Kriket",
      pl: "Krykiet",
    },
    videos: [
      {
        duration: 21334,
        id: 756,
        name: {
          en: "Murdoch University Free-Thinking Virtual Reality Cricket Experience",
          id: "Pengalaman bermain kriket realitas virtual yang membebaskan pikiran di Universitas Murdoch",
        },
        preview:
          "https://cdn.mobio360.com/Cricket/Murdoch+University+Free-Thinking+Virtual+Reality+Cricket+Experience.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Cricket/Murdoch+University+Free-Thinking+Virtual+Reality+Cricket+Experience.mp4",
      },
      // {
      //   duration: 21334,
      //   id: 757,
      //   name: {
      //     en: "VRiczat Cricket 360 Video",
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Cricket/VRiczat+Cricket+360+Video.jpeg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Cricket/VRiczat+Cricket+360+Video.mp4",
      // },
      {
        duration: 21334,
        id: 758,
        name: {
          en: "MU Scorchers VR 2022",
          id: "MU Skorcher VR 2022",
          pl: "MU Scorchers VR 2022",
        },
        preview: "https://cdn.mobio360.com/Cricket/MU+Scorchers+VR+2022.jpeg",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Cricket/MU+Scorchers+VR+2022.mp4",
      },
      {
        duration: 21334,
        id: 759,
        name: {
          en: "Peet Communities Street Cricket sponsorship activation",
          id: "Aktivasi sponsor Peet Communities Street Cricket",
          pl: "Aktywacja sponsorowania Street Cricket przez Peet Communities",
        },
        preview:
          "https://cdn.mobio360.com/Cricket/Peet+Communities+Street+Cricket+sponsorship+activation.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Cricket/Peet+Communities+Street+Cricket+sponsorship+activation.mp4",
      },
    ],
  },
  {
    id: 76,
    contents: 6,
    categoryName: {
      en: "Rugby",
      id: "Rugbi",
      pl: "Rugby",
    },
    videos: [
      {
        duration: 21334,
        id: 761,
        name: {
          en: "Experience The Haka In 360!",
          id: "Rasakan The Haka dalam 360!",
          pl: "Doświadcz Haki w 360 stopniach!",
        },
        preview:
          "https://cdn.mobio360.com/Rugby/Experience+The+Haka+In+360!.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Rugby/Experience+The+Haka+In+360!.mp4",
      },
      {
        duration: 21334,
        id: 762,
        name: {
          en: "Lions Rugby Team 360° Virtual Reality Video",
          id: "Video Virtual Reality 360° Tim Rugby Singa",
          pl: "Film w wirtualnej rzeczywistości 360° drużyny rugby Lions",
        },
        preview:
          "https://cdn.mobio360.com/Rugby/Lions+Rugby+Team+360%C2%B0+Virtual+Reality+Video.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Rugby/Lions+Rugby+Team+360%C2%B0+Virtual+Reality+Video.mp4",
      },
      {
        duration: 21334,
        id: 763,
        name: {
          en: "PLAY RUGBY IN 360° - ER7 Cup",
          id: "Mainkan rugby dalam 360° - Piala ER7",
          pl: "Grajnij w rugby w 360° - Puchar ER7",
        },
        preview:
          "https://cdn.mobio360.com/Rugby/PLAY+RUGBY+IN+360%C2%B0+-+ER7+Cup.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Rugby/PLAY+RUGBY+IN+360%C2%B0+-+ER7+Cup.mp4",
      },
      {
        duration: 21334,
        id: 764,
        name: {
          en: "SAMSUNG SCHOOL OF RUGBY - 360 VIDEO",
          id: "Sekolah Rugby Samsung - Video 360",
          pl: "SAMSUNG SZKOŁA RUGBY - WIDEO 360",
        },
        preview:
          "https://cdn.mobio360.com/Rugby/SAMSUNG+SCHOOL+OF+RUGBY+-+360+VIDEO.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Rugby/SAMSUNG+SCHOOL+OF+RUGBY+-+360+VIDEO.mp4",
      },
      {
        duration: 21334,
        id: 765,
        name: {
          en: "The 360 Tour Ashton Gate On A Bristol Rugby Matchday",
          id: "Tur 360 di Ashton Gate ing hari pertandingan rugby Bristol",
          pl: "360 Tour Ashton Gate podczas meczu rugby Bristol",
        },
        preview:
          "https://cdn.mobio360.com/Rugby/The+360+Tour+Ashton+Gate+On+A+Bristol+Rugby+Matchday.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Rugby/The+360+Tour+Ashton+Gate+On+A+Bristol+Rugby+Matchday.mp4",
      },
      {
        duration: 21334,
        id: 766,
        name: {
          en: "VIRTUAL REALITY 360° VIDEO RUGBY",
          id: "VIDEO RUGBY 360° REALITAS VIRTUAL",
          pl: "WIRTUALNA RZECZYWISTOŚĆ WIDEO 360° RUGBY",
        },
        preview:
          "https://cdn.mobio360.com/Rugby/VIRTUAL+REALITY+360%C2%B0+VIDEO+RUGBY.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Rugby/VIRTUAL+REALITY+360%C2%B0+VIDEO+RUGBY.mp4",
      },
    ],
  },
];

export let SportsVideos360CI = [
  {
    id: 91,
    contents: 2,
    categoryName: {
      en: "Football",
      id: "Sepak bola",
    },
    videos: [
      {
        duration: 21334,
        id: 761,
        name: {
          en: "FOOTBALL VR 360° Video",
          id: "Video VR 360° Sepak Bola",
        },
        preview:
          "https://cdn.mobio360.com/Football/FOOTBALL+VR+360%C2%B0+Video.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Football/FOOTBALL+VR+360%C2%B0+Video.mp4",
      },
      {
        duration: 21334,
        id: 762,
        name: {
          en: "LOSC FOOTBALL 360°EXPERIENCE",
          id: "Pengalaman sepak bola LOSC 360°",
        },
        preview:
          "https://cdn.mobio360.com/Football/LOSC+FOOTBALL+360%C2%B0EXPERIENCE.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Football/LOSC+FOOTBALL+360%C2%B0EXPERIENCE.mp4",
      },
    ],
  },
];

export let NewArrivalsVideosSA = [
  {
    id: 24,
    contents: 5,
    categoryName: {
      en: "New Arrivals",
      id: "Kedatangan baru",
    },
    videos: [
      {
        duration: 21334,
        id: 241,
        name: {
          en: "Lemur - Discovery Animal Nature",
          id: "Lemur - Penemuan Hewan Alam",
        },
        preview:
          "https://cdn.beyond-vr.com/3D+Fun/Lemur+-+Discovery+Animal+Nature.jpg",
        desc: "",
        videoUrl:
          "https://cdn.beyond-vr.com/3D+Fun/Lemur+-+Discovery+Animal+Nature.mp4",
      },
      {
        duration: 21334,
        id: 242,
        name: {
          en: "Ostriches - Discovery Nature Animal",
          id: "Burung unta - Penemuan Alam Hewan",
        },
        preview:
          "https://cdn.beyond-vr.com/3D+Fun/Ostriches+-+Discovery+Nature+Animal.jpg",
        desc: "",
        videoUrl:
          "https://cdn.beyond-vr.com/3D+Fun/Ostriches+-+Discovery+Nature+Animal.mp4",
      },
      {
        duration: 21334,
        id: 243,
        name: {
          en: "360 Rollercoaster",
          id: "Rollercoaster 360",
        },
        preview: "https://cdn.beyond-vr.com/Adventure/360+Rollercoaster.jpeg",
        desc: "",
        videoUrl: "https://cdn.beyond-vr.com/Adventure/360+Rollercoaster.mp4",
      },
      {
        duration: 21334,
        id: 244,
        name: {
          en: "Parrot In Your Hand",
          id: "Burung Beo Di Tanganmu",
        },
        preview: "https://cdn.beyond-vr.com/Adventure/Parrot+In+Your+Hand.jpeg",
        desc: "",
        videoUrl: "https://cdn.beyond-vr.com/Adventure/Parrot+In+Your+Hand.mp4",
      },
      {
        duration: 21334,
        id: 245,
        name: {
          en: "Elephant - Discovery Animal Nature",
          id: "Gajah - Penemuan Hewan Alam",
        },
        preview:
          "https://cdn.beyond-vr.com/Amazement/Elephant+-+Discovery+Animal+Nature.jpg",
        desc: "",
        videoUrl:
          "https://cdn.beyond-vr.com/Amazement/Elephant+-+Discovery+Animal+Nature.mp4",
      },
    ],
  },
];

if (config.domain === "za") Videos360 = [...SportsVideos360ZA, ...Videos360];
if (config.domain === "ci") Videos360 = [...SportsVideos360CI, ...Videos360];
if (config.domain === "sa") Videos360 = [...NewArrivalsVideosSA, ...Videos360];



// WEBPACK FOOTER //
// ./src/constants/videos.js